import React from "react";
import SkillItem from "./SkillItem";

export default function SkillList({ title, skills }) {
  return (
    <div>
      <h3>{title}</h3>
      <ul className="skills-list">
        {skills.map((skill, i) => (
          <SkillItem key={i} icon={skill.icon} name={skill.name} />
        ))}
      </ul>
    </div>
  );
}
